export default {"src":"/_next/static/media/scope_icon_rgb_black.725a9597.svg","height":395,"width":395,"blurWidth":0,"blurHeight":0};